import type { IntlDateTimeFormats } from 'vue-i18n'
import type { Locale } from '@/router/locales'

export const datetimeFormats = {
  no: {
    short: {
      dateStyle: 'short',
    },
    medium: {
      dateStyle: 'medium',
    },
    long: {
      dateStyle: 'long',
      timeStyle: 'short',
    },
  },
  en: {
    short: {
      dateStyle: 'short',
    },
    medium: {
      dateStyle: 'medium',
    },
    long: {
      dateStyle: 'long',
      timeStyle: 'short',
    },
  },
} as const satisfies IntlDateTimeFormats<Record<string, Intl.DateTimeFormatOptions>, Locale>
